module.exports = __webpack_public_path__ + "assets/medal.c2affbd3.svg";